module.exports = require("vue-property-decorator");